export const T = {
  bg: "#F7F8FA",
  surface: "#FFFFFF",
  border: "#E8EBF0",
  borderStrong: "#D1D9E6",
  text: "#000000ff",
  textSub: "#64748B",
  textMuted: "#1b2431ff",
  accent: "#3B6EF6",
  accentLight: "#EEF2FF",
  accentSoft: "#DBEAFE",
  shadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)",
  shadowHover: "0 4px 20px rgba(59,110,246,0.10), 0 1px 6px rgba(0,0,0,0.08)",
  radius: "14px",
  radiusSm: "8px",
};

export const css = {

    
  page: {
    background: T.bg,
    minHeight: "100vh",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
  },
  outerCard: {
    background: T.surface,
    border: `1px solid ${T.border}`,
    borderRadius: T.radius,
    boxShadow: T.shadow,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    paddingTop: 4,
  },
  backBtn: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    background: T.accentLight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s",
    color: T.accent,
    fontSize: 14,
    border: `1px solid ${T.accentSoft}`,
    flexShrink: 0,
  },
  pageTitle: {
    fontSize: 17,
    fontWeight: 700,
    color: T.text,
    letterSpacing: "-0.3px",
  },
  layout: {
    display: "grid",
    gridTemplateColumns: "340px 1fr",
    gap: 20,
    alignItems: "start",
  },
  sectionCard: {
    background: T.surface,
    border: `1px solid ${T.border}`,
    borderRadius: T.radius,
    boxShadow: T.shadow,
    overflow: "hidden",
  },
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 13,
    fontWeight: 600,
    color: T.text,
    letterSpacing: "0.01em",
  },
  sectionIconWrap: {
    width: 28,
    height: 28,
    borderRadius: 8,
    background: T.accentLight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: T.accent,
    fontSize: 13,
  },
  roomName: {
    fontSize: 20,
    fontWeight: 700,
    color: T.text,
    letterSpacing: "-0.5px",
  },
  roomSub: { fontSize: 12, color: T.textMuted, marginTop: 2 },
  divider: { height: 1, background: T.border, margin: "14px 0" },
  detailGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    marginTop: 4,
  },
  detailItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "10px 12px",
    background: T.bg,
    borderRadius: T.radiusSm,
    border: `1px solid ${T.border}`,
  },
  detailIconBox: {
    width: 28,
    height: 28,
    borderRadius: 7,
    background: T.surface,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: T.accent,
    fontSize: 13,
    border: `1px solid ${T.border}`,
    flexShrink: 0,
    marginTop: 1,
  },
  detailLabel: {
    fontSize: 10,
    color: T.textMuted,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    marginBottom: 2,
  },
  detailValue: { fontSize: 13, color: T.text, fontWeight: 500 },
  logPanel: {
    background: T.surface,
    border: `1px solid ${T.border}`,
    borderRadius: T.radiusSm,
    marginBottom: 10,
    overflow: "hidden",
    transition: "box-shadow 0.2s, border-color 0.2s",
  },
  logHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
  },
  dateBlock: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
  },
};



/* ─────────────────────── Status Config ─────────────────────── */
export const STATUS_CONFIG = {
    available: { dot: "#22C55E", bg: "#F0FDF4", color: "#166534", label: "Available" },
    maintenance: { dot: "#F59E0B", bg: "#FFFBEB", color: "#92400E", label: "Maintenance" },
    reserved: { dot: "#3B82F6", bg: "#EFF6FF", color: "#1E40AF", label: "Reserved" },
    occupied: { dot: "#EC4899", bg: "#FDF2F8", color: "#9D174D", label: "Occupied" },
};
export const DEFAULT_CFG = { dot: "#94A3B8", bg: "#F8FAFC", color: "#475569", label: "Unknown" };

export const LOG_STATUS = {
    check_out: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444", label: "Checked Out" },
    check_in: { bg: "#DCFCE7", text: "#166534", dot: "#22C55E", label: "Checked In" },
};